import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import EditIcon from '@mui/icons-material/Edit';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';
import CancelScheduleSendOutlinedIcon from '@mui/icons-material/CancelScheduleSendOutlined';
import { Box, Typography } from '@mui/material';

/** Departure Delay tile: ≤1 → green, ≥2 → red, null → no color */
const renderDepartureDelay = (params) => {
  const value = params.value;
  if (value == null)
    return (
      <Box
        display='flex'
        alignItems='center'
        width='100%'
        height='100%'
        sx={{ padding: '0 10px' }}
      >
        <Typography variant='body2' sx={{ width: '100%', textAlign: 'right' }}>
          —
        </Typography>
      </Box>
    );
  const bg =
    value <= 1
      ? (t) =>
          t.palette.mode === 'dark'
            ? 'rgba(46, 125, 50, 0.35)'
            : 'rgba(46, 125, 50, 0.22)'
      : (t) =>
          t.palette.mode === 'dark'
            ? 'rgba(211, 47, 47, 0.35)'
            : 'rgba(211, 47, 47, 0.22)';
  const color = value <= 1 ? 'success.main' : 'error.main';
  return (
    <Box
      display='flex'
      alignItems='center'
      width='100%'
      height='100%'
      sx={{ padding: '0 10px', backgroundColor: bg }}
    >
      <Typography
        variant='body2'
        fontWeight='medium'
        sx={{ color, width: '100%', textAlign: 'right' }}
      >
        {value}
      </Typography>
    </Box>
  );
};

const columns = (
  handleHistoryClick,
  handleEditClick,
  handleCancelClick,
  theme
) => [
  { field: 'id', headerName: 'ID' },
  { field: 'imo', headerName: 'IMO Number' },
  { field: 'vessel', headerName: 'Vessel', width: 150 },
  { field: 'departureCountryName', headerName: 'Departure Country' },
  { field: 'departurePortName', headerName: 'Departure Port' },
  { field: 'portOperatorName', headerName: 'Port Operator' },
  { field: 'destinationCountryName', headerName: 'Destination Country' },
  { field: 'destinationPortName', headerName: 'Destination Port' },
  { field: 'shippingCompanyName', headerName: 'Shipping Company' },
  { field: 'initialETDFormatted', headerName: 'Initial ETD', width: 130 },
  { field: 'actualETDFormatted', headerName: 'Latest ETD', width: 130 },
  {
    field: 'departureDelay',
    headerName: 'Departure Delay',
    width: 150,
    type: 'number',
    renderCell: renderDepartureDelay,
  },
  {
    field: 'firstPOVolumeRequest',
    headerName: 'First PO Volume Request',
    width: 150,
  },
  {
    field: 'firstShippingLineOffer',
    headerName: 'First Shipping Line Offer',
    width: 150,
  },
  { field: 'adjustedPORequest', headerName: 'Adjusted PO Request' },
  { field: 'finalAgreement', headerName: 'Final Agreement' },
  { field: 'stock', headerName: 'Stock with Blocks', width: 120 },
  { field: 'effectiveShipped', headerName: 'Effective Shipped', width: 200 },
  { field: 'initialETAFormatted', headerName: 'Initial ETA', width: 130 },
  { field: 'actualETAFormatted', headerName: 'Latest ETA', width: 130 },
  { field: 'arrivalDelay', headerName: 'Arrival Delay', width: 130 },
  { field: 'slotConfirmed', type: 'boolean', headerName: 'Slot Confirmed' },
  { field: 'generalRemarks', headerName: 'General Remarks' },
  {
    field: 'actions',
    headerName: 'Actions',
    type: 'actions',
    width: 100,
    getActions: (params) => [
      params.row.changed ? (
        <GridActionsCellItem
          icon={
            <RestoreOutlinedIcon style={{ color: theme.palette.info.main }} />
          }
          label='History'
          onClick={() => handleHistoryClick(params.row)}
        />
      ) : (
        <GridActionsCellItem
          icon={<RestoreOutlinedIcon />}
          label='History'
          disabled
        />
      ),
      <GridActionsCellItem
        icon={<EditIcon />}
        label='Edit'
        onClick={() => handleEditClick(params.row)}
      />,
      <GridActionsCellItem
        icon={<CancelScheduleSendOutlinedIcon />}
        label='Delete'
        onClick={() => handleCancelClick(params.row)}
      />,
    ],
  },
];

export default columns;
